'use strict';
const getDeviceType = () => {
    try {
        const ua = typeof navigator !== 'undefined' && navigator.userAgent ? navigator.userAgent : '';
        // iPadOS 13+ reports a desktop "Macintosh" user agent, but unlike real Macs it exposes multiple touch points
        const isIPadDesktopMode = /Macintosh/i.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1;
        if (isIPadDesktopMode || /iPad|Android(?!.*Mobi)|Tablet|Silk|PlayBook/i.test(ua)) {
            return 'tablet';
        }
        if (/Mobi|iPhone|iPod|Android|BlackBerry|Windows Phone|Opera Mini|IEMobile/i.test(ua)) {
            return 'mobile';
        }
        // touch device with an unrecognized user agent - classify by physical screen size
        if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
            const smallerDimension = window.screen ? Math.min(window.screen.width, window.screen.height) : window.innerWidth;
            return smallerDimension < 600 ? 'mobile' : 'tablet';
        }
    }
    catch (ex) {
        // fall through to desktop
    }
    return 'desktop';
};
export default {
    getDeviceType
};
